import { societeToAdapted } from "./societeAdapter";

export function utilisateurToAdapted(item) {
  //Resource
  return item
    ? {
        token: item.token,
        utilisateur_id: item.id,
        utilisateur_nom: item.nom,
        utilisateur_email: item.email,
        utilisateur_societe: societeToAdapted(item.societe),
        utilisateur_admin: item.roles[0]?.id === 1,
        roles: item.roles,
      }
    : null;
}
